import { Asset } from 'app-lib/assetUtils'
import { links } from 'bzx-common/src/config/appConfig'
import numberUtils from 'bzx-common/src/lib/numberUtils'
import { observer } from 'mobx-react'
import React from 'react'
import AssetBalance from 'shared-components/AssetBalance'
import ExternalLink from 'shared-components/ExternalLink'
import { Button, InputBasic } from 'ui-framework'
import RewardsVM from './RewardsVM'

export function StakingRewards({ vm }: { vm: RewardsVM }) {
  const { rewards } = vm

  return (
    <div className="flex-col">
      <h3 className="title-section">Staking Rewards</h3>
      <AssetBalance
        className="margin-bottom-2"
        variant="green"
        balance={rewards.ooki}
        asset={Asset.OOKI}
      />

      {rewards.ooki.gt(0.01) && (
        <p className="txt-explanation margin-bottom-2">
          <b>OOKI</b> rewards include{' '}
          <b className="txt-positive">{numberUtils.autoFormat(rewards.vestedOokiInRewards)}</b>{' '}
          <i>vested OOKI</i> from your staked vBZRX and{' '}
          <b className="txt-positive">{numberUtils.autoFormat(rewards.actualBzrxStakingRewards)}</b>{' '}
          OOKI of <i>actual staking rewards</i>.
        </p>
      )}

      <AssetBalance
        className="margin-bottom-2"
        variant="green"
        balance={rewards.stableCoin}
        asset={Asset.CRV3}
      />

      <p className="txt-explanation margin-bottom-2">
        <b>3CRV</b> is an interest earning stablecoin made up of other stablecoins. You can redeem
        them for USDC, USDT, or DAI on{' '}
        <ExternalLink className="link" href="https://www.curve.fi/3pool/withdraw">
          curve.fi
        </ExternalLink>
        . Learn more{' '}
        <ExternalLink className="link" href={links.docs.staking}>
          here
        </ExternalLink>
        .
      </p>

      <div className="margin-bottom-2">
        <InputBasic
          id="input-restake"
          type="checkbox"
          onChange={vm.set}
          onChangeEmit="name-value"
          name="inputRestake"
          value={vm.inputRestake}
        />
        <label className="margin-left-1ch txt-alternate" htmlFor="input-restake">
          Restake OOKI
        </label>
      </div>
      <Button
        isLoading={rewards.pendingStakingRewards}
        variant="blue"
        className="flex-col-end"
        disabled={!rewards.canClaimStakingRewards}
        onClick={vm.claimStakingRewards}>
        Claim {vm.inputRestake ? '& Restake' : ''}
      </Button>

      {vm.stakingStore.dao.userShouldVote && (
        <div className="margin-top-2">
          <h4 className="txt-title">Important: vote before you claim!</h4>
          <p className="txt-explanation txt-warning">
            We recommend you to{' '}
            <ExternalLink className="link" href={links.tally}>
              cast your vote
            </ExternalLink>{' '}
            for the ongoing DAO proposals first. If you claim the rewards before voting onchain, you
            will not be able to vote for the ongoing proposals (due to technical limitations).
          </p>
        </div>
      )}
    </div>
  )
}

export default observer(StakingRewards)
